import { useMutation } from '@tanstack/react-query';
import { apiService } from '../services/api';
import { AuthCredentials } from '../types/api';

export const useLogin = () => {
  return useMutation({
    mutationFn: (credentials: AuthCredentials) => apiService.login(credentials),
    onError: (error) => {
      console.error('Login failed:', error);
    },
  });
};

export const useGoogleLogin = () => {
  return useMutation({
    mutationFn: (redirectUri: string) => apiService.initGoogleLogin(redirectUri),
    onSuccess: (url: string) => {
      // Redirect to Google OAuth URL
      window.location.href = url;
    },
    onError: (error) => {
      console.error('Google login initialization failed:', error);
    },
  });
};

export const useGoogleLoginCallback = () => {
  return useMutation({
    mutationFn: ({ code, redirectUri }: { code: string; redirectUri: string }) => 
      apiService.completeGoogleLogin(code, redirectUri),
    onError: (error) => {
      console.error('Google login callback failed:', error);
    },
  });
};

export const useLogout = () => {
  return useMutation({
    mutationFn: () => {
      apiService.logout();
      return Promise.resolve();
    },
    onSuccess: () => {
      // Redirect to login page
      window.location.href = '/';
    },
  });
};

export const useCurrentUser = () => {
  return apiService.getCurrentUser();
};

export const useIsAuthenticated = () => {
  return apiService.isAuthenticated();
};